export const HomeEndpoints = {
  announcements: '/home/announcements',
  news: '/home/news',
  modules: '/home/modules',
  dismissFirstAccess: '/account/first-access',
};
